import { FEATURE_STATUS_CHANGED, SEARCH_TEXT_CHANGED } from "./actionTypes";

export const featureStatusChanged = (featuredStatus) => {
    return {
        type: FEATURE_STATUS_CHANGED,
        payload: featuredStatus,
    };
};

export const searchTextChanged = (searchText) => {
    return {
        type: SEARCH_TEXT_CHANGED,
        payload: searchText
    };
};

